import { trpc } from '../../api/trpc';

export function SystemHealth() {
  const { data: connectors } = trpc.connectors.list.useQuery();
  const connectorList = (connectors ?? []) as Array<{
    id: string;
    name: string;
    productType: string;
    status: string;
    healthStatus: string;
    toolCount?: number;
    lastHealthCheckAt?: string;
  }>;

  const healthy = connectorList.filter((c) => c.healthStatus === 'healthy').length;
  const total = connectorList.length;

  return (
    <div>
      <h2 className="settings-section-title">System Health</h2>
      <p className="settings-section-desc">Overview of connected services and system status.</p>

      <div className="health-stats">
        <div className="health-stat-card">
          <div className="health-stat-value">{total}</div>
          <div className="health-stat-label">Connectors</div>
        </div>
        <div className="health-stat-card">
          <div className="health-stat-value" style={{ color: healthy === total && total > 0 ? 'var(--sev-success)' : 'var(--sev-high)' }}>
            {healthy}/{total}
          </div>
          <div className="health-stat-label">Healthy</div>
        </div>
        <div className="health-stat-card">
          <div className="health-stat-value">
            {connectorList.reduce((sum, c) => sum + (c.toolCount ?? 0), 0)}
          </div>
          <div className="health-stat-label">Tools Available</div>
        </div>
      </div>

      <h3 className="settings-subsection-title" style={{ marginTop: 24 }}>Connector Status</h3>
      <div className="health-connector-list">
        {connectorList.length === 0 ? (
          <p className="health-empty">No connectors configured. Go to Connectors to add one.</p>
        ) : (
          connectorList.map((c) => (
            <div key={c.id} className="health-connector-row">
              <div className="health-connector-info">
                <span className="health-connector-name">{c.name}</span>
                <span className="health-connector-type">{c.productType}</span>
              </div>
              <div className="health-connector-status">
                <span className={`status-dot status-dot-${c.healthStatus === 'healthy' ? 'green' : c.healthStatus === 'degraded' ? 'yellow' : 'red'}`} />
                <span>{c.healthStatus}</span>
              </div>
              <div className="health-connector-tools">
                {c.toolCount ?? 0} tools
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
